import { Module } from 'vuex'
import { AppState, ClientPurchaseState } from '@bd/client/types'

import { state } from './state'
import { actions } from './actions'
import { mutations } from './mutations'

const purchaseOffers: Module<ClientPurchaseState, AppState> = {
  namespaced: true,
  state,
  mutations,
  actions,
}

export default purchaseOffers
